// 内容审核 — content-moderation-gate 人工复审队列.
//
// 后端: handlers/moderation/admin.go (已挂 /admin/v1/moderation)
//   GET  /admin/v1/moderation/records            (?status=&limit=&cursor=)
//   POST /admin/v1/moderation/records/:id/handle  {action: approve|remove, handled_by}
//
// status="" → 全量台账 (含 pass/block/error); status=pending_review → 人工复审队列.

import { list, post } from './client';

export type ModerationScene = 'face_upload' | 'result';
export type ModerationVerdict = 'pass' | 'review' | 'block' | 'error';
export type ModerationStatus = 'pending_review' | 'approved' | 'removed' | 'n_a';
export type ModerationAction = 'approve' | 'remove';

export interface ModerationRiskLabel {
  label: string;
  confidence: number;
}

export interface ModerationRecord {
  id: number;
  scene: ModerationScene;
  object_key: string;
  image_url: string;
  verdict: ModerationVerdict;
  risk_labels?: ModerationRiskLabel[];
  user_id?: string;
  task_id?: string;
  status: ModerationStatus;
  handled_by?: string;
  handled_at?: string;
  created_at: string;
}

/** GET /admin/v1/moderation/records */
export function listModerationRecords(params: {
  status?: string;
  cursor?: string;
  limit?: number;
}) {
  return list<ModerationRecord>('/admin/v1/moderation/records', params);
}

/** POST /admin/v1/moderation/records/:id/handle */
export function handleModerationRecord(
  id: number,
  action: ModerationAction,
  handledBy?: string,
) {
  return post<ModerationRecord>(`/admin/v1/moderation/records/${id}/handle`, {
    action,
    handled_by: handledBy,
  });
}
